import React from 'react';
import { MaterialListItem } from '../MaterialListItem/MaterialListItem';
import { useRefCallback } from '@tencent/glue-react-use';
import { getHumanSizeStr, getItemWidth, getPageSize } from '../common/utils';
import { Pagination } from '../../../Pagination';
import { usePrefixCls } from '../../../../config/hooks/usePrefixCls';
var getDesc = function getDesc(ops) {
  var width = ops.width,
    height = ops.height,
    size = ops.size;
  return "".concat(width, " x ").concat(height, "  ").concat(getHumanSizeStr(size));
};
export var MaterialList = function MaterialList(props) {
  var datasource = props.datasource,
    activeId = props.activeId,
    _props$totalSize = props.totalSize,
    totalSize = _props$totalSize === void 0 ? 0 : _props$totalSize,
    _props$pageValue = props.pageValue,
    pageValue = _props$pageValue === void 0 ? 0 : _props$pageValue,
    onPageChange = props.onPageChange,
    onActiveChange = props.onActiveChange,
    panelStyleConfig = props.panelStyleConfig;
  var activeChange = useRefCallback(onActiveChange);
  var pageChange = useRefCallback(function (val) {
    onPageChange(val);
    activeChange('');
  });
  var cls = usePrefixCls('material-library-material-list');
  if (datasource.length === 0) {
    return React.createElement(React.Fragment, null, "\u7D20\u6750\u5E93\u7A7A\u7A7A\u5982\u4E5F~");
  }
  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: "".concat(cls, "-imgs")
  }, datasource.map(function (_ref) {
    var id = _ref.id,
      url = _ref.url,
      name = _ref.name,
      width = _ref.width,
      height = _ref.height,
      size = _ref.size,
      duration = _ref.duration;
    return React.createElement(MaterialListItem, {
      onClick: activeChange,
      key: id,
      id: id,
      style: {
        width: getItemWidth(panelStyleConfig)
      },
      isActive: id === activeId,
      url: url,
      name: name,
      duration: duration,
      desc: getDesc({
        width: width,
        height: height,
        size: size
      })
    });
  })), React.createElement("div", {
    className: "".concat(cls, "-footer")
  }, React.createElement(Pagination, {
    simple: true,
    pageSize: getPageSize(panelStyleConfig),
    total: Math.ceil(totalSize),
    current: pageValue,
    onChange: pageChange
  })));
};